import { useCallback, useContext, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import QuickSelectComponent from '../../../../components/stories/organisms/top-navigation/components/quick-select/index.jsx'
import { QuickSelectContext } from '../../../../components/stories/organisms/top-navigation/components/quick-select/components/quick-select-context.jsx'
import {
  myProjectSortDirectionOptions,
  myProjectSortOptions,
  useGetMyProjectsQuery
} from '../../../../react-query/project/query/use-get-my-projects-query.jsx'

import CustomFolderItem from './custom-folder-item.jsx'
import { useHistory } from 'react-router-dom'
import { makeSelectProjectDetails } from '../../../ProjectSettings/selectors.js'
import { typeFileQuickSelectOptions } from '../../../../components/stories/organisms/top-navigation/constants.js'
import { useIntl } from 'react-intl'
import { useDebounce } from '../../../../utils/customHooks.js'

const ProjectSelectContent = () => {
  const { push } = useHistory()
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 300)
  const { isOpen } = useContext(QuickSelectContext)

  const { formatMessage } = useIntl()
  const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useGetMyProjectsQuery({
      params: {
        search: debouncedSearch,
        projectSort: myProjectSortOptions.LAST_MODIFIED,
        sortDirection: myProjectSortDirectionOptions.DESC
      },
      options: {
        enabled: isOpen
      }
    })

  const project = useSelector(makeSelectProjectDetails())

  const allProjects = useMemo(
    () => data?.pages.flatMap((page) => page.content ?? []) ?? [],
    [data]
  )

  const handleClick = (item) => {
    push(`/project/${item.id}`)
  }

  const handleScrollDown = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage])

  return (
    <>
      <QuickSelectComponent.Label
        label={project?.name ?? formatMessage({ id: 'project_Root' })}
        disabled={false}
      />
      <QuickSelectComponent.List
        isLoading={isLoading}
        setSearchValue={setSearch}
        searchValue={search}
      >
        <>
          <QuickSelectComponent.RecursiveList
            data={allProjects}
            itemComponent={
              <QuickSelectComponent.Item
                handleCallback={handleClick}
                selectedItem={project?.id ?? null}
                itemType={typeFileQuickSelectOptions.PROJECT}
              />
            }
            folderComponent={<CustomFolderItem />}
            onScrollDown={handleScrollDown}
          />
          {isFetchingNextPage && <QuickSelectComponent.LoadingItem />}
        </>
      </QuickSelectComponent.List>
    </>
  )
}

const ProjectSelect = () => {
  return (
    <QuickSelectComponent.Root>
      <ProjectSelectContent />
    </QuickSelectComponent.Root>
  )
}

export default ProjectSelect
